import o from"debug";var m=o("mud:common");export{m as a};
//# sourceMappingURL=chunk-7WIPV3R3.js.map